<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-decoration"></div>
      <h2 class="login-title">&#x2726; 登录管理后台</h2>
      <el-form :model="form" :rules="rules" ref="loginForm" @submit.native.prevent="handleLogin">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="用户名" prefix-icon="el-icon-user" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" placeholder="密码" prefix-icon="el-icon-lock"
            type="password" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="handleLogin"
            style="width:100%">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="login-tip">
        <p>默认管理员账户：admin / admin123</p>
        <p>首次使用请先初始化管理员账户</p>
      </div>
    </div>
  </div>
</template>

<script>
import { frontApi, adminApi } from '../../utils/api'

export default {
  name: 'Login',
  data() {
    return {
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const res = await frontApi.login(this.form)
          this.$store.dispatch('login', { token: res.token, user: res.user })
          this.$message.success('登录成功')
          const redirect = this.$route.query.redirect || '/admin'
          this.$router.push(redirect)
        } catch (e) {
          this.$message.error('登录失败：用户名或密码错误')
        }
        this.loading = false
      })
    },
    async initAdmin() {
      try {
        await adminApi.initAdmin({
          username: 'admin',
          password: 'admin123',
          email: 'wbxsb.site',
          nickname: '博主'
        })
        this.$message.success('管理员账户已初始化')
      } catch (e) {
        this.$message.info('管理员账户已存在')
      }
    }
  },
  created() {
    this.initAdmin()
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}
.login-card {
  width: 380px;
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.login-decoration {
  width: 40px;
  height: 3px;
  background: linear-gradient(90deg, #409EFF, #66b1ff);
  margin-bottom: 16px;
  border-radius: 2px;
}
.login-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}
.login-tip {
  text-align: center;
  color: #909399;
  font-size: 12px;
  margin-top: 12px;
  line-height: 1.8;
}
</style>
